import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import RegisterSuccessfully from 'views/pages/authentication/authentication3/RegisterSuccessfully';
import EmailValidateSuccessfully from 'views/pages/authentication/authentication3/EmailValidateSuccessfully';
import { GeneralLaw } from 'views/Home/GeneralLaw';
import { GuidelinesPage } from 'views/Home/GuidelinesPage';

const Home = Loadable(lazy(() => import('views/pages/home/index')));
const StructureAlianza = Loadable(lazy(() => import('views/pages/structureAlianza/index')));
const ContactForm = Loadable(lazy(() => import('views/pages/contactForm/index')));
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

export const publicRoutes = [
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/structure-alianza',
    element: <StructureAlianza />
  },
  {
    path: '/login',
    element: <AuthLogin3 />
  },
  {
    path: '/law-public',
    element: <GeneralLaw />
  },
  {
    path: '/contact',
    element: <ContactForm />
  },
  {
    path: '/guidelines-public',
    element: <GuidelinesPage />
  },
  {
    path: '/register',
    element: <AuthRegister3 />
  },
  {
    path: '/registerSuccess',
    element: <RegisterSuccessfully />
  },
  {
    path: '/validateEmail',
    element: <EmailValidateSuccessfully />
  }
];
